export default function leadingZero(value: number):string {
  return value / 10 >= 1
    ? value.toString()
    : ('0' + value)
}
